import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const phKey = process.env.REACT_APP_POSTHOG_KEY;
const phHost = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";
if (phKey) {
  posthog.init(phKey, {
    api_host: phHost,
    defaults: "2025-05-24",
    autocapture: true,
    capture_pageview: "history_change",
  });
}

const Tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(phKey ? <PostHogProvider client={posthog}>{Tree}</PostHogProvider> : Tree);
